<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro Plano mensal
            </a>
          </li>
        </ul>
      </div>
      <b-form class="form" @submit.stop.prevent="onSubmit">
        <div class="card-body">
          <b-tabs class="hide-tabs" v-model="tabIndex">
            <b-tab active>
              <b-row>
                <b-col md="2"></b-col>
                <b-col md="12">
                  <b-row>
                    <b-col md="3">
                      <b-form-group
                        id="cnpj"
                        label-for="cnpj"
                        label="CNPJ da Revenda"
                      >
                        <b-form-input
                          class="form-control"
                          :value="form.cnpj"
                          @input="onCnpjInput"
                          maxlength="18"
                          placeholder=""
                          style="text-transform: uppercase"
                          aria-describedby="input-1-live-feedback"
                        >
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-tab>
          </b-tabs>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-lg-12" style="text-align: center">
              <button
                type="submit"
                ref="submit_nova_plano"
                class="btn btn-primary mr-2"
              >
                Salvar
              </button>
              <button
                v-on:click="
                  () => {
                    $router.go(-1);
                  }
                "
                class="btn btn-secondary"
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import PlanoMensalData, { PlanoMensalDataRequired } from "./Data";
import ApplicationMixin from "@/modules/Application/mixins/SistemaMixin";

export default {
  name: "app-config-renovacoes-plano-form",
  props: {
    url: {
      type: String,
    },
    plano: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, ApplicationMixin],
  data() {
    return {
      tabIndex: 0,
      form: {},
      revendas: {},
      planos: [],
    };
  },
  validations: {
    form: PlanoMensalDataRequired,
  },
  mounted() {
    this.getDataInit();
  },
  methods: {
    async getDataInit() {
      if (this.plano.id) {
        this.form = this.plano;
        this.form.plano = this.numberToReal(this.form.plano);
        return;
      }

      this.form = new PlanoMensalData({});
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onCnpjInput(value) {
      const raw = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
      const prefix = raw.slice(0, 12);
      const suffix = raw.slice(12, 14).replace(/[^0-9]/g, "");
      const n = prefix + suffix;
      if (n.length <= 2) {
        this.form.cnpj = n;
      } else if (n.length <= 5) {
        this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2)}`;
      } else if (n.length <= 8) {
        this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5)}`;
      } else if (n.length <= 12) {
        this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8)}`;
      } else {
        this.form.cnpj = `${n.slice(0, 2)}.${n.slice(2, 5)}.${n.slice(5, 8)}/${n.slice(8, 12)}-${n.slice(12)}`;
      }
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_plano"];

      try {
        this.$v.form.$touch();
        console.log(this.$v.form.cnpj);
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");

        await this.$http.post(this.url, { cnpj: this.form.cnpj });

        this.$toast.success("Operação realizada com suceso!");

        this.$router.push({ name: "PlanoMensalLista" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right",
        );
      }
    },
  },
};
</script>

<style>
.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
</style>
